// import { getOrderDetails } from '@/libs/api'
import { mapGetters, mapActions } from "vuex";
import { types as Pickup } from "@/store/pickup";
const getters = mapGetters({
    getLogistics: Pickup.LOGISTICS, // 物流详情
});
const actions = mapActions({
    getOrderDetial: Pickup.ORDER_DETIAL // 订单详情
});
export default {
    name: "pickupDetail",
    data() {
        return {
            serverDetails: {
                clientCallType: "H5",
                escOrderId: "",
                buyerId: ""
            },
            order: {},
            orderPrd: {},
            delevery: {},
            logistics: {},
            orderStatusObj: {
                "3": "待付款",
                "4": "待配货",
                "5": "待签收",
                "6": "配货完成",
                "7": "已核销",
                "8": "拒收签收",
                "9": "已取消",
                "1": "已取消"
            },
            orderTtitle: {
                "1": "你的订单已关闭",
                "3": "订单未支付，请尽快支付",
                "4": "商家正在努力配货中",
                "5": "包裹正在赶来的路上",
                "7": "你的购物已完成"
            }
        };
    },
    created() {
        this.serverDetails = { ...this.serverDetails, ...{ escOrderId: this.$route.query.escOrderId }, ... { buyerId: this.$route.query.buyerOnlyid } }
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...getters
    },
    methods: {
        ...actions,
        // 获取自提订单详情
        fetch() {
            this.$toast.loading({
                duration: 0,
                mask: true,
                message: '加载中...'
            });
            this.getOrderDetial(this.serverDetails).then(res => {
                this.$toast.clear();
                if (res.returnCode === '0000') {
                    this.order = res.data;
                    this.orderPrd = res.orderPrd;
                    this.delevery = res.delevery;
                    this.logistics = res.logistics;
                }
            });
        }
    }
};